import React, { Component } from 'react';
import { Dropdown, DropdownProps, Header, Menu, Segment } from 'semantic-ui-react';
import { TipoRichiesta } from '../models';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

type TipiRichiestaProps = {
    tipiRichiesta: ReadonlyArray<TipoRichiesta>,
    currentIdTipoRichiesta: string,
    onTipoRichiestaChanged: (idTipoRichiesta: string) => void
}

export default class TipiRichiesta extends Component<TipiRichiestaProps> {

    render() {
        return (
            <div>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="computer">
                        {this.renderTipiRichiestaComputer()}
                    </Media>
                    <Media lessThan="computer">
                        {this.renderTipiRichiestaMobile()}
                    </Media>
                </MediaContextProvider>
            </div>
        );
    }

    onItemClickComputer = (_: React.MouseEvent<HTMLAnchorElement>, data: any) => {
        this.props.onTipoRichiestaChanged(data.name);
    }

    onItemClickMobile = (_: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
        this.props.onTipoRichiestaChanged(String(data.value));
    }

    renderTipoRichiestaComputer = (tipoRichiesta: TipoRichiesta) => {
        return (
            <Menu.Item
                key={tipoRichiesta.idTipoRichiesta}
                name={tipoRichiesta.idTipoRichiesta}
                active={this.props.currentIdTipoRichiesta === tipoRichiesta.idTipoRichiesta}
                onClick={this.onItemClickComputer}
            >
                {tipoRichiesta.descrizione}
            </Menu.Item>);
    }

    renderTipiRichiestaComputer = () => {
        return (
            <Menu vertical fluid>
                <Menu.Item header>
                    <Header as='h3' icon='warning sign' content='Seleziona il tipo richiesta' />
                </Menu.Item>
                {this.props.tipiRichiesta.map(this.renderTipoRichiestaComputer)}
            </Menu>);
    }

    renderTipiRichiestaMobile = () => {
        return (
            <>
                <Header as='h3' icon='home' content='Seleziona il tipo richiesta' attached='top' />
                <Segment attached='bottom'>
                    <Dropdown
                        fluid
                        selection
                        value={this.props.currentIdTipoRichiesta}
                        placeholder='Tipo richiesta...'
                        options={this.props.tipiRichiesta.map(tipo => { return { key: tipo.idTipoRichiesta, value: tipo.idTipoRichiesta, text: tipo.descrizione } })}
                        onChange={this.onItemClickMobile}
                    />
                </Segment>
            </>
        )
    }
}
